// Only HTTPS object-storage endpoints are accepted. A storage URL never receives
// the customer's API bearer token. CDN/custom-domain support requires explicit policy.
export function trustedArtifactUrl(value, message) {
  let url;
  try { url = new URL(value); } catch { throw new Error(message); }
  const azure = /^[a-z0-9]+\.blob\.core\.windows\.net$/.test(url.hostname);
  const s3 = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]\.s3\.[a-z]{2}(?:-[a-z]+)+-\d\.amazonaws\.com$/.test(url.hostname);
  if (url.protocol !== "https:" || url.username || url.password || url.port || url.hash || !(azure || s3))
    throw new Error(message);
  return url;
}

export function artifactUploadHeaders(url) {
  return url.hostname.endsWith(".blob.core.windows.net")
    ? { "x-ms-blob-type": "BlockBlob", "Content-Type": "application/octet-stream" }
    : { "Content-Type": "application/octet-stream" };
}
